import Organizacion from "./organizacion";
import {FundeoConfig} from "../../services/familia/config";


export const Fundeo = (props) => {
    return (
        <Organizacion config={FundeoConfig} {...props}/>
    )
}